"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceInfectedStatus = void 0;
var WorkspaceInfectedStatus;
(function (WorkspaceInfectedStatus) {
    WorkspaceInfectedStatus["OK"] = "Ok";
    WorkspaceInfectedStatus["WARNING"] = "Warning";
    WorkspaceInfectedStatus["CRITICAL"] = "Critical";
})(WorkspaceInfectedStatus || (exports.WorkspaceInfectedStatus = WorkspaceInfectedStatus = {}));
